import { WeaponType } from "../data/enums";

export const REFERENCE_WIDTH = 1920;
export const REFERENCE_HEIGHT = 1080;

export const WORLD_WIDTH = 3200;
export const WORLD_HEIGHT = 2400;

export const BOAT_SPEED = 280;
export const BOAT_DAMPING = 0.9;
export const BOAT_ROTATION_LERP = 0.12;

export const GAS_START_PERCENT = 100;
export const GAS_DRAIN_PER_SECOND = 1;

export const SPEAR_RANGE_PX = 220;
export const TRIDENT_RANGE_PX = 440;
export const BOW_RANGE_PX = 770;

export const TRIDENT_DURATION_MS = 30000;
export const BOW_DURATION_MS = 25000;

export const SPEAR_COOLDOWN_MS = 500;
export const PROJECTILE_SPEED = 950;
export const BASE_PROJECTILE_TINT = 0xf4f0e8;
export const PROJECTILE_TINT_BY_WEAPON: Record<WeaponType, number> = {
    [WeaponType.Spear]: 0xe6f4ff,
    [WeaponType.Trident]: 0x7fe7ff,
    [WeaponType.Bow]: 0xffd36e,
};

export const TARGET_FISH_COUNT = 16;
export const FISH_VISUAL_SCALE = 0.2;
export const FISH_CENTER_BIAS_STRENGTH = 0.02;
export const FISH_WANDER_STRENGTH = 0.38;
export const FISH_EDGE_AVOID_STRENGTH = 0.9;
export const FISH_EDGE_AVOID_MARGIN_PX = 380;
export const FISH_EDGE_SPAWN_INSET_PX = 24;
export const FISH_EDGE_SPAWN_CORNER_PADDING_PX = 140;
export const FISH_DESPAWN_BUFFER_PX = 220;

export const POWERUP_MIN_SPAWN_MS = 8000;
export const POWERUP_MAX_SPAWN_MS = 12000;
export const POWERUP_DESPAWN_MS = 20000;
export const POWERUP_MAX_ACTIVE = 3;

export const SPEED_BOOST_MULTIPLIER = 2;
export const SPEED_BOOST_DURATION_MS = 8000;
export const FISH_FRENZY_MULTIPLIER = 2;
export const FISH_FRENZY_DURATION_MS = 10000;
